export default {
  "type": "object",
  "properties": {
    "menu": {
      "type": "object",
      "properties": {
        "menu_name": {
          "type": "string"
        },
        "translation_religious_dietary_note": {
          "type": "string"
        },
        "categories": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "raw_category_name": {
                "type": "string"
              },
              "dishes": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "raw_name": {
                      "type": "string"
                    },
                    "translation_name": {
                      "type": "string"
                    },
                    "translation_ingredients": {
                      "type": "array",
                      "items": {
                        "type": "string"
                      }
                    },
                    "translation_cooking_method": {
                      "type": "string"
                    },
                    "translation_taste": {
                      "type": "array",
                      "items": {
                        "type": "string"
                      }
                    },
                    "translation_allergens": {
                      "type": "array",
                      "items": {
                        "type": "string"
                      }
                    },
                    "raw_price": {
                      "type": "number"
                    },
                    "translation_price": {
                      "type": "number"
                    },
                    "translation_description": {
                      "type": "object",
                      "properties": {
                        "brief": {
                          "type": "string"
                        },
                        "detail": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "brief",
                        "detail"
                      ]
                    },
                    "dish_options": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "raw_title": {
                            "type": "string"
                          },
                          "translation_price": {
                            "type": "number"
                          },
                          "translation_title": {
                            "type": "string"
                          },
                          "raw_price": {
                            "type": "number"
                          }
                        }
                      }
                    },
                    "dish_has_options": {
                      "type": "boolean"
                    },
                    "translation_dish_tips": {
                      "type": "string"
                    },
                    "dish_has_addon": {
                      "type": "boolean"
                    },
                    "dish_addon": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "raw_title": {
                            "type": "string"
                          },
                          "raw_price": {
                            "type": "number"
                          },
                          "translation_price": {
                            "type": "number"
                          },
                          "translation_title": {
                            "type": "string"
                          }
                        }
                      }
                    }
                  },
                  "required": [
                    "raw_name",
                    "translation_name",
                    "translation_ingredients",
                    "translation_cooking_method",
                    "translation_taste",
                    "translation_allergens",
                    "raw_price",
                    "translation_price",
                    "translation_description",
                    "dish_options",
                    "dish_has_options",
                    "dish_has_addon"
                  ],
                  "propertyOrdering":["translation_name","raw_name","translation_price","raw_price","translation_description"],
                }
              },
              "translation_category_name": {
                "type": "string"
              }
            },
            "required": [
              "raw_category_name",
              "dishes",
              "translation_category_name"
            ],
            "propertyOrdering":["raw_category_name","translation_category_name","dishes"],

          }
        },
        "menu_currency": {
          "type": "string"
        },
        "is_set_menu": {
          "type": "boolean"
        },
        "menu_language": {
          "type": "string"
        },
        "set_menu_detail": {
          "type": "object",
          "properties": {
            "raw_title": {
              "type": "string"
            },
            "raw_price": {
              "type": "number"
            },
            "translation_price": {
              "type": "number"
            },
            "translation_title": {
              "type": "string"
            }
          },
          "required": [
            "raw_title",
            "raw_price",
            "translation_price",
            "translation_title"
          ]
        }
      },
      "required": [
        "menu_name",
        "translation_religious_dietary_note",
        "categories",
        "menu_currency",
        "is_set_menu",
        "menu_language"
      ],
      "propertyOrdering":["menu_name","is_set_menu","menu_currency","translation_religious_dietary_note","categories"],
    }
  },
  "required": [
    "menu"
  ]
}